import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

interface Props {
	showModal: boolean;
	closeModal: () => void;
}

class ConfirmationModal extends React.PureComponent<Props> {

	render() {
		const { showModal, closeModal } = this.props;

		return (
			<CustomModal
				closeModal={closeModal}
				modalStyle="warning"
				showModal={showModal}
				size="sm"
			>
				<CustomModal.Header
					closeModal={closeModal}
					title="Session Expired"
				/>
				<CustomModal.Body>
					<span>Your session expired due to inactivity.</span>
				</CustomModal.Body>
				<CustomModal.Footer>
					<Button
						label="Understood"
						onClick={closeModal}
						style="primary"
					/>
				</CustomModal.Footer>
			</CustomModal>
		);
	}
}

export default ConfirmationModal;
